import { boolean } from "yargs";
import UserFund from "../../entities/UserFund";
import { SET_AUDIENCE_RECEPTION, SET_AUDIENCE_RECEPTION_ARABIC, SET_EMAIL, SET_FAX_NUMBER, SET_PHONE_ABROAD, SET_PHONE_NUMBER, SET_SERVICE_HOURS_CENTER_SERVICES, SET_SERVICE_HOURS_CENTER_SERVICES_ARABIC, SET_SERVICE_HOURS_PHONE, SET_SERVICE_HOURS_PHONE_ARABIC, SET_SMS_LINK } from "../actions/AmitimContactActions";


const initialState: ContactInitialState = {
  phoneNumber: "",
  phoneAbroad: "",
  smsLink: "",
  serviceHoursPhoneArabic: "",
  serviceHoursPhone: "",
  audienceReception: "",
  audienceReceptionArabic: "",
  email: "",
  faxNumber: "",
  serviceHoursCenterServices: "",
  serviceHoursCenterServicesArabic: "",

};

const ContactReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PHONE_NUMBER:
      return {
        ...state,
        phoneNumber: action.payload,
      };
    case SET_PHONE_ABROAD:
      return {
        ...state,
        phoneAbroad: action.payload,
      };
    case SET_SMS_LINK:
      return {
        ...state,
        smsLink: action.payload,
      };
    case SET_SERVICE_HOURS_PHONE_ARABIC:
      return {
        ...state,
        serviceHoursPhoneArabic: action.payload,
      };
    case SET_SERVICE_HOURS_PHONE:
      return {
        ...state,
        serviceHoursPhone: action.payload,
      };
    case SET_AUDIENCE_RECEPTION:
      return {
        ...state,
        audienceReception: action.payload,
      };
    case SET_AUDIENCE_RECEPTION_ARABIC:
      return {
        ...state,
        audienceReceptionArabic: action.payload,
      };
    case SET_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case SET_FAX_NUMBER:
      return {
        ...state,
        faxNumber: action.payload,
      };
    case SET_SERVICE_HOURS_CENTER_SERVICES:
      return {
        ...state,
        serviceHoursCenterServices: action.payload,
      };

    case SET_SERVICE_HOURS_CENTER_SERVICES_ARABIC:
      return {
        ...state,
        serviceHoursCenterServicesArabic: action.payload,
      };
    default:
      return state;
  }
};

export interface ContactInitialState {
  phoneNumber: string,
  phoneAbroad: string,
  smsLink: string,
  serviceHoursPhoneArabic: string,
  serviceHoursPhone: string,
  audienceReception: string,
  audienceReceptionArabic: string,
  email: string,
  faxNumber: string,
  serviceHoursCenterServices: string,
  serviceHoursCenterServicesArabic: string,
}

export default ContactReducer;
